export const shopFromWhatsNextDocuments = [
  {
    country_code: "CA",
    title: "Global Shop & Shipping Opportunities from Canada",
    mainContent: "Discover a world of shopping possibilities with our seamless shipping services from Canada.At Shippn we make international shopping and shipping from Canada simple efficient and cost-effective. If you're a shopper looking to access Canadian we've got you covered. Embrace the convenience of global shopping with Shippn. Whether you're interested in the best e-commerce platforms Canada offers or looking for cheap shipping Canada solutions we're here to help. Our dedicated hosts will swiftly handle your order and keep you informed about the order status. Whether it's your first time or you're a returning customer we're here to assist you every step of the way. Start your international shopping journey from Canada today and experience hassle-free shipping like never before.",
    sections: [
      {
        heading: "How International Shipping From Canada Works",
        content: `
              Shopping from Canada has never been easier. Simply find the products you love from the best online stores in Canada and ship them to your home country with our reliable service. Our network of hosts across Canada ensures that your parcels are forwarded quickly and safely. <br> <br> If you are a global shopper <a href="https://www.shippn.com/en/howitworks-for-shoppers">click here</a> to get detailed information about our shipping service.
            `
      },
      {
        heading: "How Much Does It Cost To Ship A Parcel From Canada?",
        content: `
              Shipping cost from Canada varies depending on several factors including weight dimensions and destination. We strive to offer cheap shipping Canada options without compromising on service quality. For example the shipping fee for a dress you buy from Canadian clothing stores will start from a minimum of $34. However this may vary depending on product and package sizes and the country you will be shipping parcels from Canada to. For example when sending a package from Canada to the Netherlands it may cost $34 but if you ship from Canada to the US it may cost a different amount.
            `
      },
      {
        heading: "How We Calculate Shipping Costs From Canada",
        content: `
              We use a transparent pricing model to calculate shipping costs from Canada. The cost is determined by the weight and size of your parcel as well as the shipping method and destination. For a detailed quote use <a href="https://www.shippn.com/en/shipping-cost-calculator">our online shipping calculator</a>.
              <br><br>Depending on your country's import regulations you may need to pay duties and taxes when your shipment arrives. We recommend checking with your local customs office to understand these potential costs.
            `
      },
      {
        heading: "How Long Does It Take To Ship From Canada?",
        content: `
              We partner with top worldwide shipping couriers including DHL Express Canada Fedex and other reputable Canada shipping companies. This ensures your parcels are delivered promptly and safely. <br> <br> Shipping times vary based on the destination and chosen shipping method. Typically international shipping from Canada can take anywhere from 3-5 business days. For exact delivery times please refer to our <a href="https://www.shippn.com/en/shipping-cost-calculator">shipping calculator</a>.
            `
      },
      {
        heading: "Top Stores Shopped From Canada",
        content: `
              Canadian online shopping offers a wide array of options. Some of the best online stores in Canada include: Amazon Canada Best Buy Canada Hudson's Bay Roots Canada Lululemon. <br> <br> These Canadian stores provide a range of products from electronics to fashion all accessible through our international shipping services. <br> <br> Experience the convenience of global shopping with Shippn. Discover the best e-commerce platforms and affordable shipping solutions in Canada. New to our <a href="https://www.shippn.com/en/bfm/explanation">'Buy For Me'</a> service? Simply <a href="https://www.shippn.com/en/signup">sign up</a> go to the 'Buy For Me' tab fill in the item details and submit your request. Our dedicated hosts will handle your purchase and keep you updated. Whether you're new or a returning customer we're here to help. Start your international shopping from Canada today with hassle-free shipping.
            `
      }
    ],
    ctaText: "Sign Up",
    ctaRoute: "signup"
  },
  {
    country_code: "US",
    title: "Global Shop & Shipping Opportunities from America",
    mainContent: `<strong>Online shopping in America</strong> opens up a world of opportunities, allowing consumers worldwide to access a vast array of products that might not be available in their home countries. With the rise of e-commerce, international shipping has become a crucial aspect of global trade. Understanding the ins and outs of <strong>shipping from the USA</strong> can help both shoppers and hosts make the most of these opportunities.`,
    sections: [
      {
        heading: "How International Shipping From America Works",
        content: `
            <strong>Shipping from the USA</strong> involves a straightforward process catering to shoppers and hosts, ensuring a seamless experience for everyone involved.
          `
      },
      {
        heading: "Worldwide Shipping Process For Shoppers",
        content: `
            Shoppers can browse and purchase products from various <strong>online stores in USA</strong>. Once an order is placed, the item is shipped to a designated address of the host in the USA. From there, the package is forwarded to the shopper's international address. This process allows shoppers to take advantage of deals and products exclusive to the US market. Explore now <a href="https://www.shippn.com/en/howitworks-for-shoppers">how it works for shoppers!</a> <br> <br>
            Also, you can sit back and relax while our personal shoppers handle all your shopping and shipping needs for you. Explore our <a href="https://www.shippn.com/en/bfm/explanation"> Buy For Me service!</a>
          `
      },
      {
        heading: "Worldwide Shipping Process For Our Hosts",
        content: `
            Hosts play a crucial role in facilitating international shipping. They receive packages on behalf of international shoppers and ensure they are correctly forwarded to their final destinations. Hosts can earn money through hosting fees, making it a lucrative opportunity for those living in the USA. Explore now <a href="https://www.shippn.com/en/howitworks-for-hosts">how it works for hosts!</a>
          `
      },
      {
        heading: "How Much Does It Cost Parcel Forwarding From USA?",
        content: `
            The cost of <strong>shipping a parcel from the USA</strong> varies depending on several factors, including the size and weight of the package,and the destination country. Generally, larger and heavier packages cost more to ship. Additionally, expedited shipping options are more expensive than standard shipping methods.
          `
      },
      {
        heading: "How We Calculate Shipping Costs From the USA",
        content: `
            We use a clear and straightforward pricing model to determine shipping costs from the USA. The price is influenced by the weight and dimensions of your package, the chosen shipping method, and the destination country. For an accurate estimate, you can use our <a href="https://www.shippn.com/en/shipping-cost-calculator">online shipping calculator.</a>
          `
      },
      {
        heading: "Which Carriers Ship From the USA?",
        content: `
          Several reputable <strong>freight forwarders in USA</strong>, providing a range of options for different needs and budgets. These include: <br><br>
          - <strong>UPS</strong>: Known for its reliability and extensive global network. <br>
          - <strong>FedEx</strong>: Offers a variety of shipping services, including express and economy options. <br>
          - <strong>DHL USA</strong>: Specializes in international shipping with a strong presence in Europe and Asia. <br>
        `
      },
      {
        heading: "How Long Does It Take To Ship From the USA?",
        content: `
        With Shippn, you can receive your package in as little as <strong>4-7 business days*</strong> thanks to our trusted logistics partners, DHL, UPS, and FedEx. These carriers provide fast and reliable shipping options, ensuring your purchases arrive at your doorstep promptly. While express shipping typically falls within this 4-7 business day window, standard shipping times may vary depending on the carrier and the destination. Keep in mind that customs processing times can add a few extra days to the overall delivery time, so it’s important to consider this when planning your purchases
      `
      },
      {
        heading: "Do I Have To Pay Duties And Taxes When Shopping From the USA?",
        content: `
      When <strong>shopping from the USA</strong>, it's important to be aware that you may be required to pay duties and taxes upon the arrival of your package in your home country. These fees are determined by the destination country's customs regulations and are typically based on the value of the imported goods. It's advisable to check with your local customs office to understand the specific duties and taxes applicable to your purchase.
    `
      },
      {
        heading: "Top USA Online Shopping Sites",
        content: `
        The USA is home to numerous popular stores that attract international shoppers. Some of the <strong>the best online shopping sites in usa</strong> include:
        <br> <br>
        <strong>- Amazon</strong>: Offers a vast selection of products across various categories. <br>
        <strong>- eBay</strong>: A popular marketplace for both new and used items. <br>
        <strong>- Walmart</strong>: Known for its affordable prices and extensive product range. <br>
        <strong>- Best Buy</strong>: A go-to destination for electronics and gadgets. <br>
        `
      },
      {
        heading: "Frequently Asked Questions About Shipping From the USA",
        content: ``
      }, {
        heading: "From What Cities In the USA Does Shippn Ship?",
        content: `
        Shippn operates from several major cities in the USA, including Virginia, California, New Jersey, Florida and Chelsea. This widespread network ensures that shoppers can take advantage of fast and efficient shipping services from key locations across the country.
        `
      },
      {
        heading: "Can I Combine Multiple Packages Into One Shipment?",
        content: `
        Yes, you can combine multiple packages into one shipment to save on shipping costs. This service, often referred to as package consolidation, allows you to receive multiple items at a single address in the USA and have them repackaged and shipped together to your international address.
        `
      },
    ],
    ctaText: "Sign Up",
    ctaRoute: "signup"
  },
  {
    "country_code": "UK",
    "title": "Global Shop & Shipping Opportunities from the UK",
    "mainContent": "<strong>The United Kingdom</strong> stands as a vibrant hub for <strong>global shopping</strong>, offering unparalleled access to some of the <strong>best brands in the UK.</strong> With Shippn, whether you're in the market for the latest <strong>ASOS UK sale</strong> items or exclusive sneakers from <strong>Foot Locker UK</strong>, you can enjoy these products no matter where you are. This service simplifies <strong>international shipping from the UK</strong>, making it easier than ever to shop from <strong>top UK clothing brands</strong> and have your items delivered right to your doorstep.",
    "sections": [
      {
        "heading": "How Shipping From the UK Works",
        "content": `
            <strong>For Shoppers</strong><br>
            Engage in <strong>shopping from the UK</strong> with ease. Shippn facilitates the delivery of your purchases by sending them to our hosts in the UK who then forward these parcels to your international address. This seamless process ensures you can enjoy <strong>womens clothing UK</strong> and <strong>mens clothing UK</strong> without leaving your home.<br><br>
            <strong>For Hosts</strong><br>
            Become a part of a global community by joining Shippn as a host. This opportunity allows you to assist shoppers worldwide in accessing <strong>UK's famous brands</strong>, while earning extra income.
          `
      },
      {
        "heading": "International Shipping to Europe (after Brexit)",
        "content": `
            Navigating the post-Brexit landscape has changed the dynamics of <strong>shipping to Europe from the UK</strong>. Shippn handles these changes with ease, ensuring your parcels are delivered without undue delays or costs.
          `
      },
      {
        "heading": "How Much Does It Cost To Ship A Parcel From the UK?",
        "content": `
            Calculate your shipping costs using our <a href="https://www.shippn.com/en/shipping-cost-calculator">shipping cost calculator</a>. Our transparent pricing accounts for the size, weight, and destination of your parcel, ensuring that you receive the most cost-effective solution for <strong>sending parcels from the UK</strong>.
          `
      },
      {
        "heading": "How We Calculate Shipping Costs From the UK",
        "content": `
            Our straightforward pricing model factors in dimensions and weight, ensuring that whether you are using our <strong>courier service UK</strong> or a specialized <strong>freight forwarder in the UK</strong>, you are getting fair and predictable pricing.
          `
      },
      {
        "heading": "Which Carriers Ship From the UK?",
        "content": `
            We partner with leading carriers such as <strong>DHL</strong>, <strong>FedEx</strong>, and <strong>UPS</strong>, making us a reliable choice for your global shopping to <strong>send a parcel from the UK</strong>.
          `
      },
      {
        "heading": "How Long Does It Take To Ship From the UK?",
        "content": `
            Your purchases can reach you in as little as <strong>1-7 business days</strong>, depending on the chosen shipping method, allowing you to enjoy products from <strong>popular UK clothing brands quickly</strong>.
          `
      },
      {
        "heading": "Do I Have To Pay Duties and Taxes When Shopping From the UK?",
        "content": `
            Navigating duties and taxes is made easier with Shippn. We provide necessary guidance on these additional costs, particularly when you're <strong>shipping to the USA from the UK</strong>.
          `
      },
      {
        "heading": "Top Stores Shopped From the UK",
        "content": `
            Explore an extensive selection of <strong>top stores in the UK</strong> such as:<br><br>
            - <strong>ASOS UK</strong>: A leader in online fashion retail, offering a diverse range of affordable and designer clothing.<br>
            - <strong>JD Sports UK</strong>: A premier retailer known for its comprehensive collection of sports apparel.<br>
            - <strong>Farfetch UK</strong>: Specializes in luxury fashion from global brands.<br>
            - <strong>New Look UK</strong>: Known for trendy, affordable apparel that caters to a young demographic.<br>
            - <strong>Foot Locker UK</strong>: Offers an extensive range of athletic footwear and sportswear, making it a go-to for sneaker enthusiasts.<br>
          `
      },
      {
        heading: "Frequently Asked Questions About Shipping From the UK",
        content: ``
      },
      {
        "heading": "From What Cities In the UK Does Shippn Ship?",
        "content": `
            Shippn operates out of major UK cities such as London and Manchester, covering a broad geographic area to facilitate efficient <strong>international shipping</strong>.
          `
      },
      {
        "heading": "Can I Combine Multiple Packages Into One Shipment?",
        "content": `
            Consolidate multiple purchases into a single shipment to save on shipping costs—a solution offered by Shippn for those who love shopping from <strong>the best online clothing stores in the UK</strong>.
          `
      },
      {
        "heading": "Do I Pay For Dimensional Weight?",
        "content": `
            Our shipping rates are calculated using the most economical method, whether based on actual or dimensional weight, ensuring that you always get the best deal available.
            <br><br>
            Dive into <strong>international shopping</strong> from the UK's finest brands and enjoy hassle-free <strong>international shipping</strong>. <a href="https://www.shippn.com/en/signup">Sign Up</a> with Shippn today and start exploring the endless possibilities. Your gateway to global fashion is just a click away!
          `
      }
    ],
    "ctaText": "Sign Up",
    "ctaRoute": "signup"
  }
]